import { render, staticRenderFns } from "./v-statictext.vue?vue&type=template&id=6e4cf53e&"
import script from "./v-statictext.vue?vue&type=script&lang=js&"
export * from "./v-statictext.vue?vue&type=script&lang=js&"
import style0 from "./v-statictext.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports